import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    title: _ctx.title,
    footer: null
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        labelCol: { span:9 },
        wrapperCol: { span: 18 },
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('save', _ctx.form)), ["prevent"])),
        id: "myForm"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, { label: "Product Category Name" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                type: "text",
                value: _ctx.form.product_category_name,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.product_category_name) = $event)),
                id: "product_category_name",
                required: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "Threshold Value" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input_number, {
                id: "threshol_value",
                value: _ctx.form.threshold_value,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.threshold_value) = $event)),
                min: 1,
                max: 10000000000,
                required: "",
                style: {"width":"100%"}
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "Positive C3" }, {
            default: _withCtx(() => [
              _createTextVNode(" X ≥ " + _toDisplayString(_ctx.form.threshold_value), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "Mariganl C3" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.form.threshold_value) + " > X ≥ 0 ", 1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "Negative C3" }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode(" X < 0 ")
            ])),
            _: 1
          }),
          _createVNode(_component_a_form_item, { "wrapper-col": { span: 18, offset: 9 } }, {
            default: _withCtx(() => [
              _createVNode(_component_a_space, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    key: "back",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('cancel')))
                  }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createTextVNode(" Cancel ")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_a_button, {
                    key: "submit",
                    type: "primary",
                    htmlType: "submit",
                    loading: false
                  }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createTextVNode(" Submit ")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}